import { TCondition } from '../types';
import { IApplicationState } from '../../../../types/types';
import { EHintKey, getHintConfig } from '../constants';
import { isHideTopBar } from '../../main/topBar/helpers/isHideTopBar';
import { getHintCanShow } from '../store/hint/selectors/getHintCanShow';

export const navPanelStarredCondition: TCondition = (
    state: IApplicationState
) => {
    const hint = getHintConfig(EHintKey.NAVIGATION_PANEL_STARRED);
    if (!hint) return false;

    return !isHideTopBar() && !!getHintCanShow(state, EHintKey.NAVIGATION_PANEL_STARRED)
};
